import {
  ENTIDADE_CHANGED,
  ENTIDADE_CURRENT_CHANGED,
  ENTIDADE_CURRENT_MEMBROS_CHANGED,
  ENTIDADE_LOGOUT,
} from "../../const/actionsType";

import { dates } from "investira.sdk";

const INITIAL_STATE = {
  data: [],
  current: { entidade: null, default_entidade_id: null, membros: [] },
  updatedAt: null,
};

const RESET_STATE = {
  ...INITIAL_STATE,
};

function entidadeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ENTIDADE_CHANGED:
      return {
        ...state,
        data: action.payload,
      };
    case ENTIDADE_CURRENT_CHANGED:
      const { entidade, default_entidade_id } = action.payload;

      sessionStorage.setItem("current_entidade", entidade);
      sessionStorage.setItem("current_entidade_id", default_entidade_id);

      return {
        ...state,
        current: { ...action.payload, membros: state.membros },
        updatedAt: dates.toDate(),
      };
    case ENTIDADE_CURRENT_MEMBROS_CHANGED:
      return {
        ...state,
        current: { ...state.current, membros: action.payload },
        updatedAt: dates.toDate(),
      };
    case ENTIDADE_LOGOUT:
      return {
        ...RESET_STATE,
      };
    default:
      return state;
  }
}

export default entidadeReducer;
